import * as React from "react";
const SvgFiRrSpiderWeb = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-spider-web_svg__a)">
      <path
        fill="#062147"
        d="M19.87 3.488A5.01 5.01 0 0 0 15.547 1H8.453A5.01 5.01 0 0 0 4.13 3.488L.677 9.434A5.2 5.2 0 0 0 0 12c.022.831.254 1.739.689 2.479l3.562 6.055a5.02 5.02 0 0 0 4.311 2.465h6.877a5.02 5.02 0 0 0 4.311-2.465l3.562-6.055c.435-.741.667-1.648.689-2.479 0-.869-.226-1.79-.677-2.566zM8.453 3h7.094q.153 0 .303.016L14.741 5H9.259L8.15 3.016q.15-.015.303-.016m5.227 8 1.672-2.993L17.09 11zm3.369 2-1.703 2.896L13.728 13zM12 14.008 13.672 17h-3.343zM10.376 7h3.248L12 9.907zm-3.457 4 1.733-2.984L10.319 11zm3.352 2-1.613 2.887L6.96 13zm-7.867-2.562 3.453-5.945q.201-.345.48-.62l1.181 2.114-2.91 5.014H2.152q.096-.29.253-.562zm3.943 9.585a3 3 0 0 1-.372-.503l-3.562-6.055a3 3 0 0 1-.222-.466h2.448l2.889 4.911zm9.09.976H8.56a3 3 0 0 1-.448-.034l1.098-1.966h5.578l1.098 1.966a3 3 0 0 1-.449.034m6.147-7.534-3.562 6.055a3 3 0 0 1-.373.503l-1.175-2.104L19.368 13h2.438q-.09.24-.222.465m-2.183-2.466-2.917-5.022 1.176-2.105q.277.276.48.62l3.453 5.945q.156.27.253.562h-2.445"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-spider-web_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpiderWeb;
